module.exports = __webpack_public_path__ + "img/medal0.748a3b19.png";